__webpack_require__.p = "https://dukana.netlify.app/";